// Groupes de pages du client (store selectPage, comme SelectPage) appliqués à une liste de pages
// Une page de plusieurs groupes figure dans chacun ; les pages hors groupe vont dans « Autres pages » (ou une liste unique sans groupe)
export function groupPages(store, pages, othersLabel) {
  const byId = new Map(pages.map(p => [String(p.id), p]))
  const inGroup = new Set()
  const groups = Object.values(store.getters['selectPage/selectPageGroups'] || {})
    .map(group => {
      const list = (group.pages || []).map(id => byId.get(String(id))).filter(Boolean)
      ;(group.pages || []).forEach(id => inGroup.add(String(id)))
      return { key: `group-${group.id}`, name: group.name, pages: list }
    })
    .filter(g => g.pages.length)
  const others = pages.filter(p => !inGroup.has(String(p.id)))
  if (!groups.length) return others.length ? [{ key: 'all', name: null, pages: others }] : []
  if (others.length) groups.push({ key: 'others', name: othersLabel, pages: others })
  return groups
}
